export default __webpack_public_path__ + "static/media/feel_good_loading.829bc229.gif";